<template>
  <div>
    <!-- <activity-flow-card
      extraClass="bg-success"
      card_title="Servicio al Cliente"
      :data="reportData"
      :map-data="{ title: 'Title', qty: 'Qty' }"
      :loading="loading"
      @push-add="handleClick"
      @click-item-qty="handleClickLink"
    >
    </activity-flow-card>  -->

    <el-card
      class="box-card activity"
      shadow="hover"
      :body-style="{ padding: '0 20px 0 20px' }"
      v-loading="loading"
    >
      <div slot="header" class="clearfix stats">
        <div class="box title">Servicio al Cliente</div>
        <el-button type="text" class="box" @click="$emit('push-add')"
          ><i class="mdi mdi-plus-circle-outline" style="font-size: 24px"></i
        ></el-button>
      </div>

      <!--:row-style="{ padding-top: '-30px'; padding-bottom: '-30px;' }"   :row-class-name="ChangeRow"-->
      <!-- <rabbey-table-3 :data="DataMock" :columns="MockColumns" /> -->

      <el-table
        :data="reportData"
        :show-header="false"
        style="width: 100%"
        class="Cardcell"
      >
        <el-table-column prop="Title"> </el-table-column>

        <el-table-column prop="Qty" width="110" align="right">
          <template slot-scope="scope">
            <el-link type="primary" @click="handleClickLink(scope.row)">
              <!--:formatter="ColorTypePorperty"-->
              <!-- {{ scope.row.Qty }} -->
              <span v-if="`${scope.row.Qty}`.includes('.')">{{
                scope.row.Qty | formatterMoney
              }}</span>
              <span
                v-else-if="
                  scope.row.Title == 'Porcentaje Visitas' ||
                  scope.row.Title == 'Porcentaje Llamadas'
                "
              >
                <ColorType :row="scope.row.Qty"> </ColorType>
              </span>
              <span
                v-else-if="
                  scope.row.Title == 'Clientes sin Portal' ||
                  scope.row.Title == 'Clientes sin App' ||
                  scope.row.Title == 'Clientes sin Portal y sin APP'
                "
              >
                <ColorType :row="scope.row.Qty"> </ColorType>
              </span>
              <!--:class="{ Rojo: rojo, Naranja: naranja, Verde: verde }" -->

              <span v-else-if="scope.row.Qty >= 0">{{ scope.row.Qty }}</span>
              <!-- <span v-if="`${scope.row.Qty}`.includes('.')">{{
              scope.row.Qty | formatterMoney
              }}</span>
              <span v-else-if="scope.row.Qty > 0">{{ scope.row.Qty }}</span> -->
            </el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column
        v-for="(column, index) in MockColumns"
        :key="index"
        :formatter="
          typeof column.formatter === 'function' ? column.formatter : null"
        v-bind="column"
      /> -->
      </el-table>
    </el-card>

    <el-drawer
      :visible.sync="drawer"
      size="80%"
      :title="title"
      @closed="OnClose"
      :destroy-on-close="true"
    >
      <CardStatDrawerHeader
        :employee="employee"
        :EmploySelectedName="EmploySelectedName"
        :itemQuantity="itemQuantity"
        :totalAmount="totalAmount"
        :totalMonthlyAmount="`${totalMonthlyAmount}`"
        :totalYearlyAmount="`${totalYearlyAmount}`"
        :totalCliente="totalCliente"
        :TotalContacts="totalContactsApp"
        :TotalContactsWithApp="totalContactWithApp"
        :totalContactWithoutApp="totalContactWithoutApp"
        :TotalContactsWithPortal="totalContactPortalWebActive"
        :TotalContactsWithoutPortal="totalContactPortalWebInactive"
        :totalContactado="totalContactado"
        :totalNoContactado="totalNoContactado"
        :Eficiencia="Eficiencia"
        :isLlamada="isLlamada"
        :isVisita="isVisita"
        :isVisitaOLlamadaLabel="isVisitaOLlamadaLabel"
        :totalContactado_A="totalContactado_A"
        :totalContactado_B="totalContactado_B"
        :totalContactado_C="totalContactado_C"
        :totalContactado_D="totalContactado_D"
        :totalNoContactado_A="totalNoContactado_A"
        :totalNoContactado_B="totalNoContactado_B"
        :totalNoContactado_C="totalNoContactado_C"
        :totalNoContactado_D="totalNoContactado_D"
        :Title="title"
        :headerTitle="title"
      />

      <!--:actions="actions"
        @rtable-push-action="handlePushAction"-->
      <rabbey-toolbox :filterables="true" @filter-search="search = $event">
        <!--
        <el-switch
          v-if="SwitchActive"
          class="SwitchButton"
          v-model="ConOsinVisitar"
          :active-text="ActiveSwitchText"
          :inactive-text="InactiveSwitchText"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
        -->
        <!--select para filtra clientes sin portal-->

        <el-select
          v-if="title === 'Clientes sin Portal'"
          class="portalAppFilter"
          size="mini"
          v-model="portalFilter"
          clearable
          placeholder="Select"
        >
          <el-option
            v-for="item in portalOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-if="title === 'Clientes sin App'"
          class="portalAppFilter"
          size="mini"
          v-model="AppFilter"
          clearable
          placeholder="Select"
        >
          <el-option
            v-for="item in AppOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </rabbey-toolbox>
      <rabbey-table3
        :data="itemsFiltered"
        :search="search"
        :columns="columns"
        :actions="actions"
        :row-class-name="tableRowClassName"
        :stripe="true"
        @rtable-push-action="handlePushAction"
        :max-height="700"
        :page-sizes="[10, 30, 50, 100, 500]"
        v-loading="loading"
      ></rabbey-table3>

      <contractDetails ref="details" :appendToBoddy="true" />
      <ContractsRenovation
        :dialogVisible="dialogVisible"
        :key="ContractsRenovationKey"
        :currentActionData="currentActionData"
        @DataSubmited="GetDetailsData"
      />
      <dialog-new-request-form
        ref="dialogNewRequest"
        :Desinstalacion="true"
        @Formsubmitted="OnFormsubmitted"
        Adjunto="Adjuntar Documento de Cancelacion con Autorizacion del cliente: "
      />
      <ContractCancellationWarning
        :ConfimrContractCancellationView="ConfimrContractCancelView"
        :CurrentActionData="currentActionData"
        @onContractCancelationConfirmation="onContractCancelationConfirmation"
        @onDialogContractCancelationClose="OnContractCancelationClose"
      />
      <ReportAppCustomerServiceDetail ref="AppCostumerServiceDetail" />
    </el-drawer>

    <record-rating ref="record_rating" @rating-success="refreshTableSuccess" />
    <request-form ref="form" />
  </div>
</template>

<script>
import axios from "axios";
import {
  complaintColumns,
  ComplaintAndClaim,
  customerColumnsCards,
  requestColumns,
  contractColumns,
  anniversaryColumns,
  missingAnniversaryColumns
} from "@/columns";
//import ActivityFlowCard from "@/components/activity_flow/ActivityFlowCard.vue";
//import { helperGetColumsItems } from "./utils.js";
import CardStatDrawerHeader from "./CardStatDrawerHeader.vue";
import RecordRating from "@/components/requests/RecordRating.vue";
import RequestForm from "@/views/modules/technical_support/requests/RequestForm.vue";
import HyperlinkPhoneNumber from "@/components/functionals/HyperlinkPhoneNumber.vue";
import LinkFormatter from "@/components/functionals/CashFlowHyperlink.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
//import {ACTIONS} from "@/views/modules/technical_support/requests/RequestList.vue"
//import { formatPhoneNumber } from "@/utils.js";
import ReportAppCustomerServiceDetail from "@/components/customer_service/reports/ReportAppCustomerServiceDetail.vue";
import ReportTerminalsHyperLink from "@/components/functionals/ReportTermianlsHyperLink.vue";
import ColorType from "@/components/functionals/ColorType.vue";
import ContractsRenovation from "@/components/activity_flow/CustomerServiceStat/ContractsRenovation.vue";
import { /*mapGetters,*/ mapActions } from "vuex";
import contractDetails from "@/components/customers/TableContractsDetails.vue";
import ContractCancellationWarning from "@/components/customer_service/Contracts/ContractCancellationWarning.vue";

export default {
  name: "CustomerServiceStat",
  props: {
    employee: {
      type: [String, Number]
    },
    employees: {
      type: Array
    },
    refreshStat: {
      type: Boolean,
      default: false
    }
  },
  components: {
    //ActivityFlowCard,
    CardStatDrawerHeader,
    "record-rating": RecordRating,
    "request-form": RequestForm,
    ReportAppCustomerServiceDetail,
    ColorType,
    ContractsRenovation,
    contractDetails,
    ContractCancellationWarning,
    "dialog-new-request-form": () =>
      import(
        /* webpackChunkName: "DialogNewRequestForm" */ "@/components/requests/DialogNewRequestForm.vue"
      )
  },
  data() {
    return {
      drawer: false,
      loading: false,
      reportData: [],
      //SwitchActive: false,
      columns: [],
      //SwitchButton
      //ActiveSwitchText: "",
      //InactiveSwitchText: "",
      //ConOsinVisitar: true,
      //actions: ACTIONS,
      items: [],
      option: "",
      title: "",
      search: "",
      EmploySelectedName: "",
      itemQuantity: 0,
      totalAmount: 0,
      totalMonthlyAmount: "",
      totalYearlyAmount: "",
      totalCliente: 0,
      Eficiencia: 0,
      totalContactWithApp: 0,
      totalContactWithoutApp: 0,
      totalContactWithPortal: 0,
      totalContactPortalWebActive: 0,
      totalContactPortalWebInactive: 0,
      totalContactsApp: 0,
      totalContactsPortal: 0,
      totalContactado: 0,
      totalContactado_A: 0,
      totalContactado_B: 0,
      totalContactado_C: 0,
      totalContactado_D: 0,
      totalNoContactado: 0,
      totalNoContactado_A: 0,
      totalNoContactado_B: 0,
      totalNoContactado_C: 0,
      totalNoContactado_D: 0,
      isLlamada: false,
      isVisita: false,
      isVisitaOLlamadaLabel: "",
      rojo: false,
      naranja: false,
      verde: false,
      page: 1,
      limit: 1000000,
      totalItems: 0,
      CustomerSearch: null,
      CustomersList: [],
      cxc_filter: "",
      status_filter: "",
      seller_filter: "",
      customers_filter: "",
      customer_clasification: "",
      customer_type: "",
      Formsubmitted: false,
      request: null,
      dialogVisible: false,
      ContractsRenovationKey: 0,
      ConfimrContractCancelView: false,
      StatusContract: "",
      currentActionData: {},
      mapColumns: {
        Requests: requestColumns,
        Customers: customerColumnsCards,
        Complaints: complaintColumns,
        //ComplaintAndClaim: ComplaintAndClaim,
        Contracts: contractColumns,
        Anniversaries: anniversaryColumns,
        MissingAnniversaries: missingAnniversaryColumns,

        RequestsDto: [
          {
            prop: "Id",
            label: "No.",
            width: 120,
            align: "center",
            sortable: true
          },
          {
            prop: "ServiceRequestTypeDescription", //Prueba campo null, porfavor funciona!!!!!!!!!!!!!!
            label: "Tipo de Solicitud",
            width: 200,
            sortable: true
          },
          {
            prop: "ClientCode",
            label: "Código de Cliente",
            width: 160,
            sortable: true
          },
          // {
          //   prop: "SLA",
          //   label: "SLA",
          //   width: 80,
          //   sortable: true
          // },
          // {
          //   prop: "StatusDescription",
          //   label: "Estado",
          //   width: 130,
          //   sortable: true
          // },
          // {
          //   prop: "ClientCode",
          //   label: "Codigo del cliente",
          //   width: 180,
          //   sortable: true
          // },
          {
            prop: "CustomerName",
            label: "Nombre del Cliente",
            width: 250,
            sortable: true
          },
          // {
          //   prop: "ContactCode",
          //   label: "Codigo del contacto"
          // },
          {
            prop: "ContactName",
            label: "Contacto"
            //width: 250
          },
          {
            prop: "ContactPhoneNumber",
            label: "Teléfono del Contacto",
            formatter: HyperlinkPhoneNumber
          },
          {
            prop: "PendingToRateDays",
            label: "Dias sin calificar",
            minWidth: 150,
            align: "center",
            sortable: true,
            formatter: ColorType
          },
          {
            prop: "CustomerService",
            label: "Servicio al Cliente",
            width: 200,
            formatter: ImagePerson,
            sortable: true,
            attrs: {
              imgKey: "CustomerServiceImage"
            }
          },
          {
            prop: "AssignedTechnicianName",
            label: "Técnico Asignado",
            width: 250,
            formatter: ImagePerson,
            sortable: true,
            attrs: {
              imgKey: "AssignedTechnicianImageUrl"
            }
          }
          // {
          //   prop: "SellerName",
          //   label: "Vendedor"
          // },
          // {
          //   prop: "ProductDescription",
          //   label: "Producto"
          // }
        ],
        AppColumns: [
          {
            prop: "CustomerCode",
            label: "Codigo Clinte",
            width: 150,
            align: "center",
            fixed: true,
            sortable: true
          },
          {
            prop: "CustomerName",
            label: "Nombre del Clinte",
            width: 350,
            sortable: true
          },
          {
            prop: "CustomerPhone",
            label: "Teléfono del Clinte",
            width: 170,
            sortable: true,
            formatter: HyperlinkPhoneNumber
          },
          /*
        {
          prop: "CustomerEmail",
          label: "Email del Cliente",
          sortable: true,
          width: 250
        },
        */

          {
            prop: "CustomerServiceName",
            label: "Servicio al Cliente",
            sortable: true,
            formatter: ImagePerson,
            attrs: {
              imgKey: "CustomerServiceImage"
            },
            width: 160
          },
          {
            prop: "SalesPersonName",
            label: "Vendedor",
            formatter: ImagePerson,
            sortable: true,
            attrs: {
              imgKey: "SalesPersonImage"
            },
            width: 190
          },
          {
            prop: "CantTotalContacts",
            label: "Total Contactos",
            sortable: true,
            width: 170,
            align: "center",
            cellAtrrs: {
              OpenTerminalsDetail: this.OpenContactsDetail
            },
            formatter: ReportTerminalsHyperLink
            //formatter: ColorTagsinLineFormatter
          },
          {
            prop: "CantContactsWithApp",
            label: "Contactos con App",
            sortable: true,
            width: 170,
            align: "center",
            cellAtrrs: {
              OpenTerminalsDetail: this.OpenContactsDetail
            },
            formatter: ReportTerminalsHyperLink
            //formatter: ColorTagsinLineFormatter
          }
          /*
          {
            prop: "CantContactsWithoutApp",
            label: "Contactos sin App",
            sortable: true,
            width: 170,
            align: "center",
            cellAtrrs: {
              OpenTerminalsDetail: this.OpenContactsDetail
            },
            formatter: ReportTerminalsHyperLink
            //formatter: ColorTagsinLineFormatter
          },
          */
          // {
          //   prop: "CantContactPortalWebActive",
          //   label: "Activo en el Portal",
          //   sortable: true,
          //   width: 170,
          //   align: "center",
          //   cellAtrrs: {
          //     OpenTerminalsDetail: this.OpenContactsDetail
          //   },
          //   formatter: ReportTerminalsHyperLink
          //   //formatter: ColorTagsinLineFormatter
          // }
          /*
        {
          prop: "CantContactPortalWebInactive",
          label: "Inactivo en el Portal",
          sortable: true,
          width: 150,
          align: "center",
          cellAtrrs: {
            OpenTerminalsDetail: this.OpenContactsDetail
          },
          formatter: ReportTerminalsHyperLink
          //formatter: ColorTagsinLineFormatter
        },
        */
          /*
        {
          prop: "EstadoPortalWeb",
          label: "Estado en el Portal",
          sortable: true,
          width: 170,
          align: "center",
          formatter: ColorTagsinLineFormatter
        },
        {
          prop: "CodigoCompania",
          label: "Cliente de la Empresa",
          sortable: true,
          width: 190,
          align: "center",
          formatter: CompanyFormatter
        },
        {
          prop: "UserRole",
          label: "Rol de usuario",
          sortable: true,
          width: 150,
          align: "center",
          formatter: CompanyFormatter
        }
        */
        ],
        PortalColumns: [
          {
            prop: "CustomerCode",
            label: "Codigo Clinte",
            width: 150,
            align: "center",
            fixed: true,
            sortable: true
          },
          {
            prop: "CustomerName",
            label: "Nombre del Clinte",
            width: 350,
            sortable: true
          },
          {
            prop: "CustomerPhone",
            label: "Teléfono del Clinte",
            width: 170,
            sortable: true,
            formatter: HyperlinkPhoneNumber
          },

          {
            prop: "CustomerServiceName",
            label: "Servicio al Cliente",
            sortable: true,
            formatter: ImagePerson,
            attrs: {
              imgKey: "CustomerServiceImage"
            },
            width: 160
          },
          {
            prop: "SalesPersonName",
            label: "Vendedor",
            formatter: ImagePerson,
            sortable: true,
            attrs: {
              imgKey: "SalesPersonImage"
            },
            width: 190
          },
          {
            prop: "CantTotalContacts",
            label: "Total Contactos",
            sortable: true,
            width: 170,
            align: "center",
            cellAtrrs: {
              OpenTerminalsDetail: this.OpenContactsDetail
            },
            formatter: ReportTerminalsHyperLink
            //formatter: ColorTagsinLineFormatter
          },
          {
            prop: "CantContactPortalWebActive",
            label: "Activo en el Portal",
            sortable: true,
            width: 170,
            align: "center",
            cellAtrrs: {
              OpenTerminalsDetail: this.OpenContactsDetail
            },
            formatter: ReportTerminalsHyperLink
            //formatter: ColorTagsinLineFormatter
          }
        ],
        PortalAppColumns: [
          {
            prop: "CustomerCode",
            label: "Codigo Clinte",
            width: 150,
            align: "center",
            fixed: true,
            sortable: true
          },
          {
            prop: "CustomerName",
            label: "Nombre del Clinte",
            width: 350,
            sortable: true
          },
          {
            prop: "CustomerPhone",
            label: "Teléfono del Clinte",
            width: 170,
            sortable: true,
            formatter: HyperlinkPhoneNumber
          },
          {
            prop: "CustomerServiceName",
            label: "Servicio al Cliente",
            sortable: true,
            formatter: ImagePerson,
            attrs: {
              imgKey: "CustomerServiceImage"
            },
            width: 160
          },
          {
            prop: "SalesPersonName",
            label: "Vendedor",
            formatter: ImagePerson,
            sortable: true,
            attrs: {
              imgKey: "SalesPersonImage"
            },
            width: 190
          },
          {
            prop: "CantTotalContacts",
            label: "Total Contactos",
            sortable: true,
            width: 170,
            align: "center",
            cellAtrrs: {
              OpenTerminalsDetail: this.OpenContactsDetail
            },
            formatter: ReportTerminalsHyperLink
            //formatter: ColorTagsinLineFormatter
          },
          {
            prop: "CantContactsWithApp",
            label: "Contactos con App",
            sortable: true,
            width: 170,
            align: "center",
            cellAtrrs: {
              OpenTerminalsDetail: this.OpenContactsDetail
            },
            formatter: ReportTerminalsHyperLink
            //formatter: ColorTagsinLineFormatter
          },
          {
            prop: "CantContactPortalWebActive",
            label: "Activo en el Portal",
            sortable: true,
            width: 170,
            align: "center",
            cellAtrrs: {
              OpenTerminalsDetail: this.OpenContactsDetail
            },
            formatter: ReportTerminalsHyperLink
            //formatter: ColorTagsinLineFormatter
          }
        ]
      },
      MockColumns: [
        {
          prop: "columnTitle"
        },
        {
          prop: "Qty",
          width: "50",
          formatter: LinkFormatter
        }
      ],
      DataMock: [
        {
          columnTitle: "Clientes sin llamar",
          Qty: "254"
        },
        {
          columnTitle: "Clientes sin visitar",
          Qty: "42"
        },
        {
          columnTitle: "Oportunidades vencidas",
          Qty: "3"
        },
        {
          columnTitle: "Cierres de la semana",
          Qty: "12"
        },
        {
          columnTitle: "Cierres del mes",
          Qty: "350"
        },
        {
          columnTitle: "Instalaciones abiertas",
          Qty: "45"
        },
        {
          columnTitle: "Instalaciones cerradas del mes",
          Qty: "164"
        },
        {
          columnTitle: "Citas de la semana",
          Qty: "984"
        },
        {
          columnTitle: "Citas del mes",
          Qty: "458"
        },
        {
          columnTitle: "Aniversarios de clientes en el mes actual",
          Qty: "678"
        },
        {
          columnTitle: "Contactos sin fecha de cumpleaños",
          Qty: "675"
        }
      ],
      actions: [
        /*
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view-command",
          condition: row => !row.ServiceRequestTypeDescription //Si la solicitud NO tiene un campo "Tipo de Solicitud" entonces muestra este action
        },
        */
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view-validation-request-command",
          condition: (row) => row.ServiceRequestTypeDescription //Si la solicitud tiene un campo "Tipo de Solicitud" entonces muestra este action
        },
        {
          icon: "el-icon-plus",
          label: "Calificar",
          command: "rate-validation-request-command",
          condition: (row) => row.ServiceRequestTypeDescription
        },
        {
          icon: "el-icon-view",
          label: "Ver Lineas de Contrato",
          command: "view-contract-Lines-command",
          condition: (row) => {
            //console.log("condition: ", row);
            return row.NoContrato !== undefined;
          } //Si la solicitud tiene un campo "Tipo de Solicitud" entonces muestra este action
        },
        {
          icon: "el-icon-date",
          label: "Renovar Contrato",
          command: "contract-renovation-command",
          condition: (row) => {
            //console.log("condition: ", row);
            return row.NoContrato !== undefined;
          }
        },

        {
          icon: "el-icon-s-release",
          label: "Cancelar Contrato",
          command: "contract-cancelation-command",
          condition: (row) => {
            //console.log("condition: ", row);
            return row.NoContrato !== undefined;
          }
        }
      ],
      ratedRequestIndex: "",
      portalOptions: [
        {
          value: 1,
          label: "Con portal"
        },
        {
          value: 2,
          label: "Sin portal"
        },
        {
          value: 0,
          label: "Todos"
        }
      ],
      portalFilter: 2,
      AppOptions: [
        {
          value: 1,
          label: "Con App"
        },
        {
          value: 2,
          label: "Sin App"
        },
        {
          value: 0,
          label: "Todos"
        }
      ],
      AppFilter: 2
    };
  },
  created() {
    if (this.$store.state.products.list.length <= 0) {
      this.$store.dispatch("products/all");
    }
    this.getReportData();
  },
  computed: {
    /*
    ...mapGetters({
      UserList: "navixy/getUserList",
      getActualhash: "navixy/getActualhash",
      getActualUserList: "navixy/getActualUserList"
    })
    */
    /*
    ColorTypePorperty: function(a) {
      return ColorType
    }
    */
    itemsFiltered() {
      let datafiltered;
      if (this.title === "Clientes sin Portal") {
        //console.log("items", this.items)

        switch (this.portalFilter) {
          case 0: {
            //console.log("hola", this.portalFilter)
            datafiltered = this.items;
            break;
          }
          case 1: {
            //console.log("hola", this.portalFilter)
            datafiltered = this.items.filter(
              (item) => item.CantContactPortalWebActive > 0
            );
            break;
          }
          case 2: {
            //console.log("hola", this.portalFilter)
            datafiltered = this.items.filter(
              (item) => item.CantContactPortalWebActive === 0
            );
            break;
          }
        }
      } else if (this.title === "Clientes sin App") {
        //console.log("items", this.items)

        switch (this.AppFilter) {
          case 0: {
            //console.log("hola", this.portalFilter)
            datafiltered = this.items;
            break;
          }
          case 1: {
            //console.log("hola", this.portalFilter)
            datafiltered = this.items.filter(
              (item) => item.CantContactsWithApp > 0
            );
            break;
          }
          case 2: {
            //console.log("hola", this.portalFilter)
            datafiltered = this.items.filter(
              (item) => item.CantContactsWithApp === 0
            );
            break;
          }
        }
      } else {
        datafiltered = this.items;
      }

      return datafiltered;
    }
  },
  methods: {
    ...mapActions({
      //getUserList: "navixy/getUserList",
      UpdateNavixyUser: "navixy/updateNavixyUser"
      //ObtainActualUserInfo: "navixy/ObtainActualUserInfo",
    }),
    handleClick() {
      this.drawer = true;
    },
    getReportData() {
      //console.log("employe: ",this.employee )
      //console.log("employees: ",this.employees )

      if (this.request) {
        this.request.cancel();
      }
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };

      this.loading = true;
      this.$http
        .get("/api/MessageApi/GetExcutiveStat", {
          cancelToken: axiosSource.token,
          timeout: 3 * 60 * 1000,
          params: {
            CompanyCode: this.currentCompany,
            UserName: this.currentUser.UserName,
            ExecutiveCode: this.currentUser.PersonCode,
            CustomerServicesCode: this.currentUser.CustomerServiceExec_,
            EmployeeId: this.employee,
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1
          }
        })
        .then((resp) => {
          this.reportData = resp.data;
          // this.reportData.forEach(card => {
          //   if (card.Title == "Clientes con o sin App") {
          //     card.Title = "Clientes (App - Portal)";
          //   }
          // });

          this.loading = false;
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.loading = false;
        });
    },
    GetDetailsData(option /*, contacted = 1*/) {
      //console.log("Get Details Data: " , option);
      this.dialogVisible = false;
      let Parameters = {
        params: {
          CompanyCode: this.currentCompany,
          SellerCode: this.currentUser.PersonCode,
          CustomerServicesCode: this.currentUser.CustomerServiceExec_, //!= null ? this.currentUser.CustomerServiceExec_ : 0,
          EmployeeId: this.employee,
          UserId: this.currentUser.UserID,
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          optionStr: option ?? this.option
        }
      };

      this.loading = true;
      this.EmploySelectedName = this.employees.filter(
        (employee) => employee.EmployeeID === this.employee
      )[0].Name;
      // console.log("Employees: ", this.employees.filter(employee => employee.EmployeeID === this.employee)[0].Name /*map(employee => employee.Name)*/)
      this.$http
        .get("/api/MessageApi/GetExcutiveStatDetails", Parameters)
        .then((response) => {
          /*
          console.log("Contratos antes del switch: ", this.items,
                        "\n this option: ", this.option);
          */
          //let filtered = [];

          switch (option ?? this.option) {
            case "v":
            case "l": {
              /*
              filtered = response.data[0].Customers;
              this.items = filtered.filter(item => item.Contacted == contacted);
              */
              this.items = response.data[0].Customers;
              this.itemQuantity = this.items.length;

              if (this.items[0].TypeOf === "visita") {
                this.items = this.items.filter(
                  (item) =>
                    item.CustomerClassification >= 1 &&
                    item.CustomerClassification <= 4
                );
                this.itemQuantity = this.items.length;
                this.isVisita = true;
                this.isVisitaOLlamadaLabel = "Visitados";
                this.totalContactado = this.items.filter(
                  (item) => item.Contacted === 1
                ).length;
                this.totalContactado_A = this.items.filter(
                  (item) =>
                    item.Contacted === 1 && item.CustomerClassification === 1
                ).length;
                this.totalContactado_B = this.items.filter(
                  (item) =>
                    item.Contacted === 1 && item.CustomerClassification === 2
                ).length;
                this.totalContactado_C = this.items.filter(
                  (item) =>
                    item.Contacted === 1 && item.CustomerClassification === 3
                ).length;
                this.totalContactado_D = this.items.filter(
                  (item) =>
                    item.Contacted === 1 && item.CustomerClassification === 4
                ).length;
                this.totalNoContactado = this.items.filter(
                  (item) => item.Contacted === 0
                ).length;
                this.totalNoContactado_A = this.items.filter(
                  (item) =>
                    item.Contacted === 0 && item.CustomerClassification === 1
                ).length;
                this.totalNoContactado_B = this.items.filter(
                  (item) =>
                    item.Contacted === 0 && item.CustomerClassification === 2
                ).length;
                this.totalNoContactado_C = this.items.filter(
                  (item) =>
                    item.Contacted === 0 && item.CustomerClassification === 3
                ).length;
                this.totalNoContactado_D = this.items.filter(
                  (item) =>
                    item.Contacted === 0 && item.CustomerClassification === 4
                ).length;
                this.Eficiencia = Math.round(
                  (this.totalContactado / this.items.length) * 100
                );
              } else if (this.items[0].TypeOf === "llamada") {
                this.items = this.items.filter(
                  (item) =>
                    item.CustomerClassification >= 1 &&
                    item.CustomerClassification <= 4
                );
                this.itemQuantity = this.items.length;
                this.isLlamada = true;
                this.isVisitaOLlamadaLabel = "Llamados";
                this.totalContactado = this.items.filter(
                  (item) => item.Contacted === 1
                ).length;
                this.totalContactado_A = this.items.filter(
                  (item) =>
                    item.Contacted === 1 && item.CustomerClassification === 1
                ).length;
                this.totalContactado_B = this.items.filter(
                  (item) =>
                    item.Contacted === 1 && item.CustomerClassification === 2
                ).length;
                this.totalContactado_C = this.items.filter(
                  (item) =>
                    item.Contacted === 1 && item.CustomerClassification === 3
                ).length;
                this.totalContactado_D = this.items.filter(
                  (item) =>
                    item.Contacted === 1 && item.CustomerClassification === 4
                ).length;
                this.totalNoContactado = this.items.filter(
                  (item) => item.Contacted === 0
                ).length;
                this.totalNoContactado_A = this.items.filter(
                  (item) =>
                    item.Contacted === 0 && item.CustomerClassification === 1
                ).length;
                this.totalNoContactado_B = this.items.filter(
                  (item) =>
                    item.Contacted === 0 && item.CustomerClassification === 2
                ).length;
                this.totalNoContactado_C = this.items.filter(
                  (item) =>
                    item.Contacted === 0 && item.CustomerClassification === 3
                ).length;
                this.totalNoContactado_D = this.items.filter(
                  (item) =>
                    item.Contacted === 0 && item.CustomerClassification === 4
                ).length;
                this.Eficiencia = Math.round(
                  (this.totalContactado / this.items.length) * 100
                );
              }

              for (const i in this.items) {
                var str = this.items[i].Description.replace(
                  /(<([^>]+)>)/gi,
                  ""
                );
                var html = str;

                var div = document.createElement("div");
                div.innerHTML = html;
                var text = div.textContent || div.innerText || "";

                this.items[i].Description = text;
              }
              break;
            }
            // case "l": {
            //   this.items = response.data[0].Customers;
            //   break;
            // }

            case "sa": {
              this.items = response.data[0].Solicitudes;
              this.itemQuantity = this.items.length;
              break;
            }
            case "sp": {
              this.items = response.data[0].RequestsDto;
              //console.log("sp items: ", this.items)
              this.itemQuantity = this.items.length;
              break;
            }
            case "q": {
              this.items = response.data[0].ComplaintsAndClaims;
              this.itemQuantity = this.items.length;
              break;
            }
            case "cv":
            case "cm":
            case "cp": {
              this.items = response.data[0].Contracts;
              this.itemQuantity = this.items.length;
              //console.log("Contratos: ", this.items);
              this.totalAmount = this.items
                .map((item) => item.Amount)
                .reduce((prev, curr) => prev + curr, 0);
              this.totalYearlyAmount = this.items
                .filter((item) => item.TipoProcesoLabel === "Anual")
                .map((item) => item.Amount)
                .reduce((prev, curr) => prev + curr, 0);
              this.totalMonthlyAmount = this.items
                .filter((item) => item.TipoProcesoLabel === "Mensual")
                .map((item) => item.Amount)
                .reduce((prev, curr) => prev + curr, 0);
              break;
            }
            case "app": {
              let data = response.data[0].ClientWithOrWithoutApps;

              let ClienteArray = [];

              data.forEach((cliente) => {
                let usoapp = Boolean;

                let TotalContacts = cliente.ContactsWithOrWithoutApp;

                let ContactsWithApp = cliente.ContactsWithOrWithoutApp.filter(
                  (Contact) => Contact.LoginQTY > 0
                );

                let ContactsWithoutApp =
                  cliente.ContactsWithOrWithoutApp.filter(
                    (Contact) => Contact.LoginQTY <= 0
                  );

                let ContactPortalWebActive =
                  cliente.ContactsWithOrWithoutApp.filter(
                    (Contact) =>
                      Contact.EstadoProtalWeb > 0 &&
                      Contact.EstadoProtalWeb != null
                  );

                let ContactPortalWebInactive =
                  cliente.ContactsWithOrWithoutApp.filter(
                    (Contact) =>
                      Contact.EstadoProtalWeb == null ||
                      Contact.EstadoProtalWeb == 0
                  );

                ContactPortalWebInactive.forEach((contact) => {
                  if (contact.ContactPortalWebInactive == null) {
                    contact.ContactPortalWebInactive = 0;
                  }
                });

                if (cliente.LoginQTY > 0) {
                  usoapp = true;
                } else {
                  usoapp = false;
                }
                ClienteArray.push({
                  UsoApp: usoapp,
                  TotalContacts: TotalContacts,
                  CantTotalContacts: TotalContacts.length,
                  ContactsWithApp: ContactsWithApp,
                  ContactsWithoutApp: ContactsWithoutApp,
                  CantContactsWithApp: ContactsWithApp.length,
                  CantContactsWithoutApp: ContactsWithoutApp.length,
                  ContactPortalWebActive: ContactPortalWebActive,
                  ContactPortalWebInactive: ContactPortalWebInactive,
                  CantContactPortalWebActive: ContactPortalWebActive.length,
                  CantContactPortalWebInactive: ContactPortalWebInactive.length,

                  ...cliente
                });
              });

              //self.Resultado = ClienteArray;

              this.items = ClienteArray;
              this.itemQuantity = this.items.length;

              this.totalContactWithApp = this.items.filter(
                (item) => item.CantContactsWithApp > 0
              ).length;

              this.totalContactWithoutApp = this.items.filter(
                (item) => item.CantContactsWithApp === 0
              ).length;
              /*
              console.log(
                "this.totalContactWithApp: ",
                this.totalContactWithApp
              );
              */
              /*
                this.items
                .map(item => item.CantContactsWithApp)
                .reduce((prev, curr) => prev + curr, 0);
                */
              this.totalContactPortalWebActive = this.items.filter(
                (item) => item.CantContactPortalWebActive > 0
              ).length;

              this.totalContactPortalWebInactive = this.items.filter(
                (item) => item.CantContactPortalWebActive === 0
              ).length;
              /*
              console.log(
                "this.totalContactPortalWebActive: ",
                this.totalContactPortalWebActive
              );
              */
              /*
                this.items
                .map(item => item.CantContactPortalWebActive)
                .reduce((prev, curr) => prev + curr, 0);
                */
              this.totalContactsApp = this.items.filter(
                (item) => item.CantTotalContacts > 0
              ).length;
              //console.log("this.totalContactsApp: ", this.totalContactsApp);
              /*
                this.items
                .map(item => item.CantTotalContacts)
                .reduce((prev, curr) => prev + curr, 0);
                */
              break;
            }
            case "portal": {
              let data = response.data[0].ClientWithOrWithoutPortal;

              let ClienteArray = [];

              data.forEach((cliente) => {
                let usoapp = Boolean;

                let TotalContacts = cliente.ContactsWithOrWithoutPortal;

                let ContactsWithPortal =
                  cliente.ContactsWithOrWithoutPortal.filter(
                    (Contact) => Contact.LoginQTY > 0
                  );

                let ContactsWithoutPortal =
                  cliente.ContactsWithOrWithoutPortal.filter(
                    (Contact) => Contact.LoginQTY <= 0
                  );

                let ContactPortalWebActive =
                  cliente.ContactsWithOrWithoutPortal.filter(
                    (Contact) =>
                      Contact.EstadoProtalWeb > 0 &&
                      Contact.EstadoProtalWeb != null
                  );

                let ContactPortalWebInactive =
                  cliente.ContactsWithOrWithoutPortal.filter(
                    (Contact) =>
                      Contact.EstadoProtalWeb == null ||
                      Contact.EstadoProtalWeb == 0
                  );

                ContactPortalWebInactive.forEach((contact) => {
                  if (contact.ContactPortalWebInactive == null) {
                    contact.ContactPortalWebInactive = 0;
                  }
                });

                if (cliente.LoginQTY > 0) {
                  usoapp = true;
                } else {
                  usoapp = false;
                }
                ClienteArray.push({
                  UsoApp: usoapp,
                  TotalContacts: TotalContacts,
                  CantTotalContacts: TotalContacts.length,
                  ContactsWithApp: ContactsWithPortal,
                  ContactsWithoutApp: ContactsWithoutPortal,
                  CantContactsWithApp: ContactsWithPortal.length,
                  CantContactsWithoutApp: ContactsWithoutPortal.length,
                  ContactPortalWebActive: ContactPortalWebActive,
                  ContactPortalWebInactive: ContactPortalWebInactive,
                  CantContactPortalWebActive: ContactPortalWebActive.length,
                  CantContactPortalWebInactive: ContactPortalWebInactive.length,

                  ...cliente
                });
              });

              this.items = ClienteArray;
              this.itemQuantity = this.items.length;

              this.totalContactWithApp = this.items.filter(
                (item) => item.CantContactsWithApp > 0
              ).length;

              this.totalContactWithoutApp = this.items.filter(
                (item) => item.CantContactsWithApp === 0
              ).length;

              this.totalContactPortalWebActive = this.items.filter(
                (item) => item.CantContactPortalWebActive > 0
              ).length;

              this.totalContactPortalWebInactive = this.items.filter(
                (item) => item.CantContactPortalWebActive === 0
              ).length;

              this.totalContactsApp = this.items.filter(
                (item) => item.CantTotalContacts > 0
              ).length;

              break;
            }
            case "portalApp": {
              let data = response.data[0].ClientWithOrWithoutAppOrPortal;

              let ClienteArray = [];

              data.forEach((cliente) => {
                let usoapp = Boolean;

                let TotalContacts = cliente.ContactsWithOrWithoutApp;

                let ContactsWithApp = cliente.ContactsWithOrWithoutApp.filter(
                  (Contact) => Contact.LoginQTY > 0
                );

                let ContactsWithoutApp =
                  cliente.ContactsWithOrWithoutApp.filter(
                    (Contact) => Contact.LoginQTY <= 0
                  );

                let ContactPortalWebActive =
                  cliente.ContactsWithOrWithoutApp.filter(
                    (Contact) =>
                      Contact.EstadoProtalWeb > 0 &&
                      Contact.EstadoProtalWeb != null
                  );

                let ContactPortalWebInactive =
                  cliente.ContactsWithOrWithoutApp.filter(
                    (Contact) =>
                      Contact.EstadoProtalWeb == null ||
                      Contact.EstadoProtalWeb == 0
                  );

                ContactPortalWebInactive.forEach((contact) => {
                  if (contact.ContactPortalWebInactive == null) {
                    contact.ContactPortalWebInactive = 0;
                  }
                });

                if (cliente.LoginQTY > 0) {
                  usoapp = true;
                } else {
                  usoapp = false;
                }
                ClienteArray.push({
                  UsoApp: usoapp,
                  TotalContacts: TotalContacts,
                  CantTotalContacts: TotalContacts.length,
                  ContactsWithApp: ContactsWithApp,
                  ContactsWithoutApp: ContactsWithoutApp,
                  CantContactsWithApp: ContactsWithApp.length,
                  CantContactsWithoutApp: ContactsWithoutApp.length,
                  ContactPortalWebActive: ContactPortalWebActive,
                  ContactPortalWebInactive: ContactPortalWebInactive,
                  CantContactPortalWebActive: ContactPortalWebActive.length,
                  CantContactPortalWebInactive: ContactPortalWebInactive.length,

                  ...cliente
                });
              });

              //self.Resultado = ClienteArray;

              this.items = ClienteArray;
              this.itemQuantity = this.items.length;

              this.totalContactWithApp = this.items.filter(
                (item) => item.CantContactsWithApp > 0
              ).length;

              this.totalContactWithoutApp = this.items.filter(
                (item) => item.CantContactsWithApp === 0
              ).length;

              this.totalContactPortalWebActive = this.items.filter(
                (item) => item.CantContactPortalWebActive > 0
              ).length;

              this.totalContactPortalWebInactive = this.items.filter(
                (item) => item.CantContactPortalWebActive === 0
              ).length;

              this.totalContactsApp = this.items.filter(
                (item) => item.CantTotalContacts > 0
              ).length;

              //console.log("PortalAppResponse: ", response);
              break;
            }
            case "a":
            case "f": {
              this.items = response.data[0].MissingAnniversaries;
              this.itemQuantity = this.items.length;
              break;
            }
            default: {
              console.error("Se recibio una opcion no valida");
              break;
            }
          }

          this.loading = false;
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.loading = false;
        });
    },
    handleClickLink(props) {
      /*
      const report = this.reportData.find(f => f.Title === props.title);
      const { items, columns } = helperGetColumsItems(report, this.mapColumns);

      this.items = items;
      this.columns = columns;
      */
      this.title = props.Title;

      this.totalAmount = props.qty; // Gets total items to display it on the header of the drawer
      this.itemQuantity = this.items.length; // Gets total items to display it on the header of the drawer
      this.columns = [];
      switch (props.Title) {
        case "Porcentaje Llamadas": {
          this.columns = customerColumnsCards;
          let option = (this.option = "l");
          //this.ActiveSwitchText = "Clientes llamados";
          //this.InactiveSwitchText = "Clientes sin llamar";
          //this.SwitchActive = true;
          this.GetDetailsData(option);
          break;
        }
        case "Porcentaje Visitas": {
          this.columns = customerColumnsCards;
          let option = (this.option = "v");
          //this.ActiveSwitchText = "Clientes visitados";
          //this.InactiveSwitchText = "Clientes sin Visitar";
          //this.SwitchActive = true;
          this.GetDetailsData(option);
          break;
        }

        case "Solicitudes abiertas": {
          this.columns = requestColumns;
          let option = (this.option = "sa");
          //this.SwitchActive = false;
          this.GetDetailsData(option);
          break;
        }

        case "Solicitudes por calificar": {
          this.columns = this.mapColumns.RequestsDto;
          let option = (this.option = "sp");
          //this.SwitchActive = false;
          this.GetDetailsData(option);
          break;
        }
        case "Quejas abiertas": {
          this.columns = ComplaintAndClaim;
          let option = (this.option = "q");
          //this.SwitchActive = false;
          this.GetDetailsData(option);
          break;
        }
        case "Contratos vencidos": {
          this.columns = contractColumns;
          let option = (this.option = "cv");
          //this.SwitchActive = false;
          this.GetDetailsData(option);
          break;
        }
        case "Contratos vencen este mes": {
          this.columns = contractColumns;
          let option = (this.option = "cm");
          //this.SwitchActive = false;
          this.GetDetailsData(option);
          break;
        }
        case "Contratos vencen el mes proximo": {
          this.columns = contractColumns;
          let option = (this.option = "cp");
          //this.SwitchActive = false;
          this.GetDetailsData(option);
          break;
        }
        case "Clientes sin App": {
          this.columns = this.mapColumns.AppColumns;
          let option = (this.option = "app");
          //this.SwitchActive = false;
          this.GetDetailsData(option);
          break;
        }
        case "Clientes sin Portal": {
          this.columns = this.mapColumns.PortalColumns;
          let option = (this.option = "portal");
          //this.SwitchActive = false;
          this.GetDetailsData(option);
          break;
        }
        case "Clientes sin Portal y sin APP": {
          this.columns = this.mapColumns.PortalAppColumns;
          let option = (this.option = "portalApp");
          this.GetDetailsData(option);
          break;
        }
        case "Aniversarios de Contactos": {
          this.columns = missingAnniversaryColumns;
          let option = (this.option = "a");
          //this.SwitchActive = false;
          this.GetDetailsData(option);
          break;
        }
        case "Contactos sin fecha de cumpleaños": {
          this.columns = missingAnniversaryColumns;
          let option = (this.option = "f");
          //this.SwitchActive = false;
          this.GetDetailsData(option);
          break;
        }

        default: {
          console.error("no matchan los titulos de la columna");
          break;
        }
      }

      this.drawer = true;
    },
    OnClose() {
      this.items = [];
      this.itemQuantity = 0;
      this.totalYearlyAmount = "0";
      this.totalMonthlyAmount = "0";
      this.isVisita = false;
      this.isLlamada = false;
      this.Eficiencia = 0;
      this.totalContactado = 0;
      this.totalContactado_A = 0;
      this.totalContactado_B = 0;
      this.totalContactado_C = 0;
      this.totalContactado_D = 0;
      this.totalNoContactado = 0;
      this.totalNoContactado_A = 0;
      this.totalNoContactado_B = 0;
      this.totalNoContactado_C = 0;
      this.totalNoContactado_D = 0;
      //this.ConOsinVisitar = true;
      this.totalContactWithApp = 0;
      this.totalContactWithoutApp = 0;
      this.totalContactWithPortal = 0;
      this.totalContactPortalWebActive = 0;
      (this.totalContactPortalWebInactive = 0), (this.totalContactsApp = 0);
      this.totalContactsPortal = 0;
    },
    async handlePushAction(action) {
      //let self = this;
      //let clientCode = "CL999999";
      //let CurrentClient;
      switch (action.command) {
        case "view-command": {
          this.$message({
            type: "warning",
            message:
              "Esta acción todavía no está habilitada. Disculpe los inconvenientes."
          });
          break;
        }
        case "view-validation-request-command": {
          this.$refs.form.draw(action.row.Id);
          break;
        }

        case "rate-validation-request-command": {
          this.$refs.record_rating.show(action.row);
          this.ratedRequestIndex = this.items.findIndex(
            (row) => row.Id === action.row.Id
          );
          break;
        }
        case "contract-renovation-command":
          //console.log("action: ", action);
          this.currentActionData = action;
          /*
          console.log(
            "currentActionData en el action: ",
            this.currentActionData
          );
          */
          this.dialogVisible = true;
          this.ContractsRenovationKey++;
          break;
        case "contract-cancelation-command":
          this.currentActionData = action;

          //this.InactivateNavixyUser(action.row.ClientCode);
          this.ConfimrContractCancelView = true;

          // this.$confirm(
          //   "Estas apunto de cerrar este contrato en navision y de generar un ticket de desinstalacion para todas sus lineas de contrato, asi como para desactivar el usuario del cliente en navixy." +
          //     "\n\n <strong>Seguro que desea continuar?</strong>",
          //   "Cuidado !",
          //   {
          //     dangerouslyUseHTMLString: true,
          //     confirmButtonText: "OK",
          //     cancelButtonText: "Cancel",
          //     type: "warning"
          //   }
          // )
          //   .then(async () => {
          //     this.$message({
          //       type: "info",
          //       message: `Procedemos con el con la solicitud de desinstalacion del contrato: #${action.row.NoContrato}`
          //     });

          //     await this.fecthCustomers();
          //     await this.CustomersList;
          //     CurrentClient = this.CustomersList.filter(
          //       (Cust) => Cust.ClientCode === action.row.ClientCode
          //     )[0];
          //     /*
          //     console.log(
          //       "CustomersList: ",
          //       this.CustomersList,
          //       "\nAction row: ",
          //       action.row,
          //       "\nCurrent client: ",
          //       CurrentClient
          //     );
          //     */

          //     await this.$refs.dialogNewRequest.show(
          //       action.row.ClientCode,
          //       CurrentClient
          //     );
          //   })
          //   .catch(() => {
          //     this.$message({
          //       type: "info",
          //       message: `Cierre del contrato: #${action.row.NoContrato} Cancelado`
          //     });
          //   });

          //this.CancelContractConfirmation
          /*
          this.$confirm(
            "This will permanently delete the file. Continue?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning"
            }
          )
            .then(() => {
              this.$message({
                type: "success",
                message: "Delete completed"
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Delete canceled"
              });
            });
            */
          break;

        case "view-contract-Lines-command":
          //console.log("details props: ", action);
          this.$refs.details.show(action);
          break;
      }
    },
    async OnFormsubmitted() {
      //console.log("Putazos");
      this.Formsubmitted = true;

      /*
      console.log(
        "entre a cancelacion de contratos NoContrato: ",
        this.currentActionData.row.NoContrato
      );
      */

      //let clientCode = "CL999999";

      /*
      let params = {
          "contractNumber" : this.currentActionData.row.NoContrato

      };
      */
      this.$http
        .post(
          "/api/contracts/CloseContract" +
            `?contractNumber=${this.currentActionData.row.NoContrato}&StatusContract=${this.StatusContract}`
        )
        .then((resp) => {
          resp;
          //console.log("respuesta de contrato cerrado: ", resp);
        })
        .catch((err) => {
          console.error("errado de contrato cerrado: ", err);
        })
        .finally(() => {
          this.GetDetailsData(this.option);
        });

      this.InactivateNavixyUser(this.currentActionData.row.ClientCode);
    },

    async InactivateNavixyUser(clientCode) {
      //console.log("ClientCode en InactivateNavixyUser: ", clientCode);
      /*
                "entre a cancelacion de contratos: ",
                this.currentActionData,
                "\n UserList: ",
                this.UserList,
                "\n getUserList: ",
                await this.getUserList,
                "\n NewUserList: ",
                this.UserList,

                "\n filteredUserList: ",
                this.UserList.filter(
                  (user) => user.post_region === this.currentActionData.row.ClientCode
                ),

                "\n getActualhash: ",
                this.getActualhash,
                "\n ObtainActualUserList: ",
                await this.ObtainActualUserList,
                "\n getActualUserList: ",
                this.getActualUserList(clientCode),
                */
      /*
      console.log(
        "\n ObtainActualUserInfo: ",

        await this.UpdateNavixyUser(clientCode, this)
      );
      */
      //let self = this;
      let udated = await this.UpdateNavixyUser(
        clientCode,
        this.callbackUserNoFound /*, self*/
      );
      //console.log("updated final: ",udated)
      if (udated === true) {
        this.$message({
          showClose: true,
          message: "Se ha inhabilitado el usuario en navixy correctamente",
          type: "success"
        });
      } else {
        this.$message({
          showClose: true,
          message: "ha ocurrido un error al inhabilitar el usuario en navixy",
          type: "danger"
        });
      }
    },
    callbackUserNoFound(/*err*/) {
      //console.log ("Error no found in Database: ", err)
    },
    /*
    InlineButtonEvent(){
        console.log("InlineButtonEvent: ");
        //this.$refs.details.show(action)
    },
    */
    refreshTableSuccess() {
      this.items.splice(this.ratedRequestIndex, 1);
    },
    OpenContactsDetail(row, type) {
      this.$refs.AppCostumerServiceDetail.show(row, type);
    },
    tableRowClassName({ row, row: { QTY_Navixi, Qty } }) {
      //console.log("tableRowClassName row", row);
      row;
      if (QTY_Navixi !== Qty) {
        return "danger-row";
      }
      /*
      const now = this.$moment();
      var diference = now.diff(this.$moment(CreatedAt), "days");
      if (diference > SlaDaysToResponse) {
        return "warning-row";
      }
      return "";
      */
    },
    async fecthCustomers() {
      this.Customeritems = [];
      this.loading = true;
      await this.$http
        .get("/api/customers", {
          timeout: 3 * 60 * 1000,
          params: {
            Page: this.page,
            Limit: this.limit,
            CompanyId: this.currentCompany,
            SalesPersonCode: this.seller_filter,
            Name: this.CustomerSearch,
            CustomerService: this.customers_filter,
            Contract: this.status_filter,
            AccountReceivable: this.cxc_filter,
            clasificaction: this.customer_clasification.value,
            ClientType: this.customer_type
          }
        })
        .then((resp) => {
          const { Items, ItemCount, CurrentPage } = resp.data;
          //console.log("fecthCustomers filterList resp: ", resp.data);
          this.CustomersList = Items;
          //this.filterList = Items;
          this.totalItems = ItemCount;
          this.page = CurrentPage;
        })
        .catch((error) => {
          this.filterList = [];
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async onContractCancelationConfirmation(statusContract, action) {
      let CurrentClient;
      this.StatusContract = statusContract;
      this.ConfimrContractCancelView = false;
      //this.isCancelationConfirmed =
      this.$message({
        type: "info",
        message: `Procedemos con el con la solicitud de desinstalacion del contrato: #${action.row.NoContrato}`
      });

      await this.fecthCustomers();
      await this.CustomersList;
      CurrentClient = this.CustomersList.filter(
        (Cust) => Cust.ClientCode === action.row.ClientCode
      )[0];
      /*
              console.log(
                "CustomersList: ",
                this.CustomersList,
                "\nAction row: ",
                action.row,
                "\nCurrent client: ",
                CurrentClient
              );
              */
      //console.log("legue aqui klk action : ", action)
      //console.log("CurrentClient: ", CurrentClient)
      await this.$refs.dialogNewRequest.show(
        action.row.ClientCode,
        CurrentClient
      );
    },
    OnContractCancelationClose(val, action, fromCancel) {
      this.ConfimrContractCancelView = val;

      //this.isCancelationConfirmed = false
      if (fromCancel) {
        this.$message({
          type: "info",
          message: `Cierre del contrato: #${action.row.NoContrato} Cancelado`
        });
      }
    }
  },
  watch: {
    refreshStat() {
      this.getReportData();
    },
    employee() {
      this.getReportData();
    },
    reportData: function () {
      this.reportData.forEach((Title) => {
        if (Title.Qty < 80 || Title.Qty == 0) {
          this.rojo = true;
          this.verde = false;
          this.naranja = false;
        }
        if (Title.Qty >= 80 && Title.Qty < 90) {
          this.naranja = true;
          this.rojo = false;
          this.verde = false;
        }
        if (Title.Qty >= 90) {
          this.verde = true;
          this.rojo = false;
          this.naranja = false;
        }
      });
    },
    CancelContractConfirmation() {
      this.$confirm(
        "This will permanently delete the file. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.$message({
            type: "success",
            message: "Delete completed"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled"
          });
        });
    }
    // ConOsinVisitar(val) {
    //   let option;
    //   if (this.title == "Porcentaje Visitas") {
    //     option = "v";
    //   } else if (this.title == "Porcentaje Llamadas") {
    //     option = "l";
    //   }

    //   let filtered = [];
    //   if (val) {
    //     //let contacted = 1;
    //     this.GetDetailsData(option /*, contacted*/);
    //     /*
    //     filtered = this.items.filter(item => item.Contacted == 1);
    //      this.items =  filtered;
    //      */
    //   } else {
    //     //let contacted = 0;
    //     this.GetDetailsData(option /*, contacted*/);
    //     /*
    //     filtered =  this.items.filter(item => item.Contacted == 0);
    //      this.items =  filtered;
    //      */
    //   }
    // }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";
.box-card.activity {
  width: 100%;

  .el-card__header {
    // background: #2484c4;
    padding: 0;

    .clearfix {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-items: center;
      font-weight: 900;
      font-size: 14px;
      text-transform: uppercase;
      color: #ffffff;
      margin: 0;
      padding: 0;

      &.stats {
        background: $text-color-accent;
      }

      button {
        float: right;
        align-self: flex-end;
        padding: 3px 0;
        color: #ffffff;

        span {
          padding-bottom: 6px;
        }
      }
    }
  }
}
/*
.rowline {
  margin-bottom: 0px;
  margin: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  font-size: 100px;
}

.el-table_1_column_1
  .el-table_1_column_2
  .el-table_2_column_3
  .el-table_2_column_4 {
  padding-bottom: 0px;
  padding-top: 0px;
}
*/
.Verde {
  color: green;
}
.Naranja {
  color: orange;
}
.Rojo {
  color: rgba(255, 0, 0, 0.712);
}

.cell {
  line-height: 13px !important;
}
.el-tooltip {
  tooltip-position: "bottom";
}
.SwitchButton {
  padding: auto;
  margin: auto;
}
.el-table .danger-row {
  background: #ffdddd;
}
.portalAppFilter {
  padding-right: 10px;
}
</style>
